import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { CallsPage } from 'pages/conversations/pages/calls/ui/callsPage'

export const CallsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route path={'/'} element={<CallsPage />} />
    </RoutesWithNotFound>
  )
}
